/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { setNewPin } from '../store/actions/auth';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    margin: 0,
    color: '#1e3f9e',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  pin: {
    padding: '40px 50px',
  },
  button: {
    minWidth: 80,
    padding: '0.6rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const PinChangeModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = useSelector((state) => state.admin.currentUserInfo);
  const [generatedPin, setGeneratedPin] = useState(null);

  const handleClose = () => {
    const payload = {
      username: user.username.toLowerCase(),
      pin: generatedPin,
    };
    dispatch(setNewPin(payload));
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      setGeneratedPin(`000${Math.floor(Math.random() * 10000)}`.slice(-4));
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <h2 className={classes.title}>New PIN</h2>
          <h2 className={classes.pin}>{generatedPin}</h2>
          <Button className={classes.button} size="small" variant="contained" onClick={handleClose}>
            Ok
          </Button>
        </div>
      </Fade>
    </Modal>
  );
};

PinChangeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default PinChangeModal;
